module.exports = __webpack_public_path__ + "img/user-check-01.bb966c5d.svg";